<template>
	<div>
		<div class="firstScreen">
			<NavBar />
			<div class="parent">
				<div class="text">
					<Hero />
					<div class="store_links_box">
						<div
							v-if="os !== 'Android'"
							@click="() => openLink('ios')"
							style="cursor: pointer; display:inline-block;"
						>
							<img
								src="@/assets/as_badge.png"
								style="width: 175px; border-radius: 7px; "
							/>
						</div>
						<div style="height: 15px" />
						<div
							v-if="os !== 'iOS'"
							style="cursor: pointer;display:inline-block;"
							@click="() => openLink('android')"
						>
							<img
								style="width: 175px; border-radius: 7px;"
								src="@/assets/gp_badge.png"
							/>
						</div>
					</div>
				</div>
				<Mockups />
			</div>
		</div>
		<div class="link">
			<a :href="mail_href" target="_blank">Contact</a>
		</div>
	</div>
</template>

<script>
import { NavBar, Hero, Mockups } from "@/components/Home";

export default {
	components: {
		NavBar,
		Hero,
		Mockups,
	},
	data() {
		return {
			mail_href:
				"mailto:victor@alduin.com?subject=User Feedback&body=Hey Victor! %0d%0a %0d%0a Here are a few feedbacks for Alduin:%0d%0a %0d%0a–%0d%0a–%0d%0a–",
		};
	},
	computed: {
		os() {
			return this.getOS();
		},
	},
	methods: {
		openLink(store) {
			if (store === "ios")
				window.open("https://testflight.apple.com/join/MUvI90np", "_blank");
			else if (store === "android")
				window.open(
					"https://play.google.com/store/apps/details?id=com.alduin",
					"_blank"
				);
		},
		getOS() {
			var userAgent = window.navigator.userAgent,
				platform = window.navigator.platform,
				macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
				windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
				iosPlatforms = ["iPhone", "iPad", "iPod"],
				os = null;

			if (macosPlatforms.indexOf(platform) !== -1) {
				os = "Mac OS";
			} else if (iosPlatforms.indexOf(platform) !== -1) {
				os = "iOS";
			} else if (windowsPlatforms.indexOf(platform) !== -1) {
				os = "Windows";
			} else if (/Android/.test(userAgent)) {
				os = "Android";
			} else if (!os && /Linux/.test(platform)) {
				os = "Linux";
			}

			return os;
		},
	},
};
</script>

<style scoped>
.firstScreen {
	height: 100vh;
	width: 100vw;
}
.parent {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.text {
	width: 45%;
	padding-left: 10%;
	text-align: left;
}

.link a {
	color: #639ffa;
	font-family: Calibre, Helvetica Neue, Segoe UI, Helvetica, Arial,
		Lucida Grande, sans-serif;
	font-size: 17px;
	-webkit-font-smoothing: antialiased;
	font-weight: 500;
	line-height: 50px;
	margin: 0 15px;
	transition: opacity 0.2s ease-in;
	z-index: 10000;
	text-decoration: none;
}
.link a:hover {
	color: #3385ff;
	border-bottom: 2px solid #3385ff;
	border-radius: 1.5px;
	padding-bottom: 2px;
	cursor: pointer;
}

@media only screen and (max-width: 750px) {
	.feature {
		width: 100%;
		margin-bottom: 5vh;
	}

	.link {
		position: relative;
	}
	.store_links_box {
		display: flex;
		width: 100%;
		justify-content: center;
	}
	.catchprase {
		text-align: center;
	}
}
.header a {
	text-decoration: none;
}
@media only screen and (max-width: 1500px) {
	.text {
		padding-left: 15%;
	}
}
@media only screen and (max-width: 1200px) {
	.text {
		padding-left: 10%;
	}
}

img {
	pointer-events: none;
}
@media only screen and (max-width: 950px) {
	.text {
		padding-left: 5%;
	}
}
@media only screen and (max-width: 750px) {
	.sub-text {
		font-size: 18px;
	}

	.text {
		min-width: 100vw;
		height: 100vh;
		padding: 10px 10vw 40px;
	}
	.parent {
		background: none;
		flex-direction: column;
	}
	.text {
		padding: 0;
	}
	.catchprase {
		font-size: 22px;
		margin-top: 30px;
		line-height: 35px;
		color: #3385ff;
		margin: 10px;
		margin-left: 20px;
		text-align: left;
	}
	.sub-text {
		margin-bottom: 20px;
		color: #2c3e50;
	}

	.text {
		z-index: 100;
		background-color: transparent;
	}

	.mobile {
		position: relative;
		margin-top: 50px;
		margin-bottom: 30px;
	}
}

@font-face {
	font-family: "Comfortaa";
	src: local("Comfortaa"),
		url(../assets/fonts/Comfortaa-Regular.ttf) format("truetype");
}
@font-face {
	font-family: "Comfortaa-SemiBold";
	src: local("Comfortaa-SemiBold"),
		url(../assets/fonts/Comfortaa-SemiBold.ttf) format("truetype");
}
</style>
